var borderGetters;
(function (borderGetters) {
    borderGetters["GET_BORDERS"] = "GET_BORDERS";
    borderGetters["GET_BORDER_PARENTS"] = "GET_BORDER_PARENTS";
    borderGetters["GET_BORDER_CHILDS"] = "GET_BORDER_CHILDS";
    borderGetters["GET_PARENT_BORDERS"] = "GET_PARENT_BORDERS";
})(borderGetters || (borderGetters = {}));
export default borderGetters;
